import { NgFor, UpperCasePipe } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import { Metadata } from 'src/app/models/robot-family-metadata';
import { UNICODE } from '../../constants/general-constants';
import { ReplaceUnderscorePipe } from '../../pipes/replace-underscore.pipe';

@Component({
  selector: 'app-metadata-table-cell',
  templateUrl: './metadata-table-cell.component.html',
  styleUrls: ['./metadata-table-cell.component.css'],
  imports: [
    MatTable,
    MatSort,
    NgFor,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    UpperCasePipe,
    ReplaceUnderscorePipe
  ]
})
export class MetadataTableCellComponent implements OnInit, AfterViewInit {
  @Input() public tableData: Metadata[];

  @ViewChild(MatTable) public table: MatTable<Metadata>;
  @ViewChild(MatSort) public sort: MatSort;

  public displayedColumns = ['extent_type', 'confidence', 'priority'];
  public dataSource = new MatTableDataSource();

  constructor() {}

  public ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  public ngOnInit() {
    this.dataSource.data = this.tableData;
    this.dataSource.sortingDataAccessor = this.customSortingDataAccessor;
  }

  public customSortingDataAccessor(data: any, sortHeaderId: string): string {
    if (typeof data[sortHeaderId] === 'boolean') {
      return data[sortHeaderId].toString();
    }
    if (typeof data[sortHeaderId] === 'string') {
      return data[sortHeaderId].toLowerCase();
    }
    if (!data[sortHeaderId]) {
      if (this.sort.direction === 'desc') {
        return UNICODE.NULL + UNICODE.NULL + UNICODE.NULL;
      }

      return UNICODE.MAX_CHAR + UNICODE.MAX_CHAR + UNICODE.MAX_CHAR;
    }

    return data[sortHeaderId];
  }
}
